import { render, staticRenderFns } from "./SubMenu.vue?vue&type=template&id=908ba374&scoped=true&"
import script from "./SubMenu.vue?vue&type=script&lang=js&"
export * from "./SubMenu.vue?vue&type=script&lang=js&"
import style0 from "./SubMenu.vue?vue&type=style&index=0&id=908ba374&prod&scoped=true&lang=scss&"
import style1 from "./SubMenu.vue?vue&type=style&index=1&id=908ba374&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "908ba374",
  null
  
)

export default component.exports